const KEY = 'MARKET_CATEGORY';

export function readMarketCategory() {
  const str = localStorage.getItem(KEY);
  return str ? JSON.parse(str) : {};
}

export function writeMarketCategory(data) {
  localStorage.setItem(KEY, JSON.stringify(data));
}
